import React from 'react';

const Banner = ({ text, icon, href }) => (
  <a href={href} className="banner" target="_blank" rel="noopener noreferrer">
    <div className="banner-left">
      <div className="banner-icon">{icon}</div>

      <div className="banner-text">{text}</div>
    </div>

    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 1.01562C0.640625 0.890625 0.585938 0.75 0.585938 0.59375C0.585938 0.421875 0.648438 0.273438 0.773438 0.148438C0.882813 0.0390625 1.02344 -0.0078125 1.19531 0.0078125C1.35156 0.0078125 1.48438 0.0625 1.59375 0.171875L8.71875 7.29688C8.90625 7.48438 9 7.71875 9 8C9 8.26563 8.90625 8.5 8.71875 8.70313L1.59375 15.8281C1.46875 15.9375 1.32812 15.9922 1.17188 15.9922C1.01562 15.9922 0.875 15.9375 0.75 15.8281C0.640625 15.7031 0.585938 15.5625 0.585938 15.4062C0.585938 15.2344 0.640625 15.0938 0.75 14.9844L7.73438 8L0.75 1.01562Z"
        fill="#EC7000"
      />
    </svg>

    <style jsx>{`
      .banner {
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0px 0px 3px rgba(16, 25, 32, 0.05), 0px 2px 4px rgba(6, 21, 33, 0.05);
        border-radius: 4px;
        color #231D19;
        padding: 20px;
        border-left: 4px solid transparent;
        text-decoration: none;
        cursor: pointer;
        transition: border-color .35s ease, box-shadow .35s ease;
        margin-bottom: 24px;
      }

      .banner:hover {
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.02), 0px 8px 16px rgba(0, 0, 0, 0.06);
        border-left: 4px solid #EC7000;
      }

      .banner-left {
        display: flex;
        align-items: center;
      }

      .banner-icon {
        margin-right: 1em;
      }

      .banner-text {
        font-family: 'ItauDisplay', sans-serif;
        font-size: 20px;
        line-height: 26px;
        font-weight: bold;
      }
    `}</style>
  </a>
);

export default Banner;
